var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu",style:({
    width: _vm.matchContentWidth ? 'auto' : _vm.width + 'px'
  })},[_c('ul',{staticClass:"menu__content"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.itemSelected(item.id)}}},[(item.icon)?_c('v-icon',{staticClass:"menu__content__icon",attrs:{"size":_vm.iconSize}},[_vm._v(_vm._s(item.icon)+"\n      ")]):_vm._e(),_vm._v(" "),(item.content)?_c('span',[_vm._v(_vm._s(item.content))]):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }